// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import RequestForm from './RequestForm';
import Payment from './Payment';
import PaymentOptions from './PaymentOptions';
import FlutterwavePayment from './FlutterwavePayment'; // placeholder
import PaypalPayment from './PaypalPayment'; // placeholder
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/request-form" element={<RequestForm />} />
        <Route path="/payment-options" element={<PaymentOptions />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/flutterwave-payment" element={<FlutterwavePayment />} />
        <Route path="/paypal-payment" element={<PaypalPayment />} />
        <Route path="/payment" element={<Payment />} />
        {/* other routes */}
      </Routes>
    </Router>
  );
}

export default App;
